import type { CSSProperties } from 'react';
import { useListRow } from '../List/ListRowContext';

interface TextProps {
  text: string;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body' | 'caption';
  field?: string;
  className?: string;
  style?: CSSProperties;
}

const VARIANT_CLASSES: Record<string, string> = {
  h1: 'text-3xl font-bold',
  h2: 'text-2xl font-semibold',
  h3: 'text-xl font-semibold',
  h4: 'text-lg font-medium',
  h5: 'text-base font-medium',
  h6: 'text-sm font-medium',
  body: 'text-sm',
  caption: 'text-xs text-gray-500 dark:text-gray-400',
};

// Heading variants map to the matching heading tag so the page outline,
// screen-reader navigation, and SEO of shared/public surfaces reflect the
// authored structure. body/caption stay flow-level / inline respectively.
const VARIANT_ELEMENT = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body: 'p',
  caption: 'span',
} as const;

export function TextView({ text, variant = 'body', field, className, style }: TextProps) {
  const row = useListRow();
  const displayText = field && row ? String(row[field] ?? text) : text;
  const variantClass = VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.body;
  const Element = VARIANT_ELEMENT[variant] ?? 'p';
  return (
    <Element className={`${variantClass}${className ? ` ${className}` : ''}`} style={style}>
      {displayText}
    </Element>
  );
}
